/**
 * Created by Todd Yu on 06/20/2020.
 * Description:
 * Effects for handling Note Types page of Admin Page
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';

import { AdminPageActionTypes } from '../../actions/admin-page.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { EntityTypeService } from '../../../tamalelibs/services/entity-type.service';


@Injectable()
export class AdminPageEntityTypeEffects {
    constructor(
        private _entityTypeService: EntityTypeService,
        private _actions$: Actions
    ) { }

    getEntityTypesEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.GET_ENTITY_TYPES),
        mergeMap(() => this._entityTypeService.getAdminPageEntityList()
            .pipe(
                map(entityTypeData => ({
                    type: AdminPageActionTypes.GET_ENTITY_TYPES_SUCCESS,
                    payload: entityTypeData
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${err.message}`
                    });
                })
            )
        )
    ));

    newEntityTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.CREATE_NEW_ENTITY_TYPE),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._entityTypeService.createNewEntityType(payload.name, payload.data)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.CREATE_NEW_ENTITY_TYPE_SUCCESS,
                    payload: {
                        newEntity: response,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.name}-${err.message}`
                    });
                })
            )
        )
    ));

    deleteEntityTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.DELETE_ENTITY_TYPE),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._entityTypeService.deleteEntityType(payload.id)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.DELETE_ENTITY_TYPE_SUCCESS,
                    payload: {
                        id: payload.id,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.id}-${err.message}`
                    });
                })
            )
        )
    ));

    editEntityTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.EDIT_ENTITY_TYPE),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._entityTypeService.editEntityType(payload.name, payload.id, payload.data)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.EDIT_ENTITY_TYPE_SUCCESS,
                    payload: {
                        newEntity: response,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.id}-${err.message}`
                    });
                })
            )
        )
    ));

    editEntityDefaultTypeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.EDIT_DEFAULT_ENTITY),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._entityTypeService.editEntityType(payload.name, payload.id, payload.data)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.EDIT_DEFAULT_ENTITY_SUCCESS,
                    payload: {
                        data: response,
                        defaultTypeField: payload.defaultTypeField,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.id}-${err.message}`
                    });
                })
            )
        )
    ));

    toggleEntityCredentialEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.TOGGLE_ENTITY_DISPLAY),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._entityTypeService.editEntityType(payload.name, payload.id, payload.data)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.TOGGLE_ENTITY_DISPLAY_SUCCESS,
                    payload: {
                        data: response,
                        credentialField: payload.credentialField,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.id}-${err.message}`
                    });
                })
            )
        )
    ));

}
